import request from "@/api";
import type { ScheduleVo, Page, ScheduleDateVo, ScheduleForm, SchedulePagingQueryParam } from "@zhihaoscm/entity";
import type { Pageable } from "@/entity/base/BaseEntity";
import { BaseService } from "@/api/services/baseService";
import { confirmable } from "@/utils/decorator/confirmable";

export interface ScheduleDateVoParam extends Pageable {
    endTime: string;
    beginTime: string;
    productId?: string;
    orderId?: string;
}

export class ScheduleService extends BaseService<ScheduleDateVo, ScheduleDateVo, ScheduleForm, unknown> {
    /** 根据排期日期查询并分组 - 排期日历 */
    public async scheduleDate(params: ScheduleDateVoParam): Promise<ScheduleDateVo[]> {
        const { data } = await this.service.get(`${this.path}/schedule-date`, {
            params
        });
        return data;
    }

    /** 分页查询 - 排期列表分页 */
    public async schedulePaging(params: SchedulePagingQueryParam): Promise<Page<ScheduleDateVo>> {
        const { data } = await this.service.get(`${this.path}/paging`, {
            params
        });
        return data;
    }

    /** 新增排期 */
    public async add(params: ScheduleForm): Promise<ScheduleDateVo> {
        const { data } = await this.service.post(`${this.path}`, params);
        return data;
    }

    /** 修改排期 */
    public async update(id: string, params: ScheduleForm): Promise<ScheduleDateVo> {
        const { data } = await this.service.put(`${this.path}/${id}`, params);
        return data;
    }

    /** 删除排期 */
    @confirmable("确定要删除排期吗？")
    public async delete(id: string): Promise<ScheduleDateVo> {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }

    /** 总排期吨数 */
    public async amount(params: { productId: string }) {
        const { data } = await this.service.get(`${this.path}/amount`, {
            params
        });
        return data;
    }

    /** 下拉 */
    public async selectList(params: {
        id?: string;
        keyword?: string;
        orderId: string;
        states: number[];
    }): Promise<ScheduleVo[]> {
        const { data } = await this.service.get(`${this.path}/selector`, {
            params
        });
        return data;
    }
}
export const scheduleService = new ScheduleService("/admin/schedule", request.service);
